var _path, _path2, _path3, _path4, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1134 236.16071",
    fill: "#495971",
    fontFamily: "Laca Medium",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#87C7D1",
    d: "m 110.54995,205.74908 c 29.13714,-1.24024 57.49156,-17.31597 66.32824,-48.24179 h 36.60785 c -15.23897,51.07153 -58.7093,77.284 -102.9361,78.65341 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABD9E0",
    d: "m 167.89048,133.78938 c 0,32.51223 -27.31058,58.86852 -60.99918,58.86852 -33.688605,0 -60.998849,-26.35629 -60.998849,-58.86852 0,-29.89331 46.977304,-105.206859 60.638059,-132.2810191 8.69863,17.1164301 61.35997,109.0021791 61.35997,132.2810191 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 0.297261,157.50729 h 36.607825 c 8.836338,30.92582 37.190753,46.99981 66.327944,48.24179 V 236.1607 C 59.005856,234.79027 15.5362,208.57882 0.297261,157.50729 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 101.10576,151.90419 135.70593,149.97714 70.351802,1.5087009 18.944733,105.86856 C 32.138087,98.326483 43.771339,94.227093 57.637125,94.799043 L 70.29269,70.538581 87.625065,111.94351 C 47.897039,104.94265 21.706803,117.37302 0,150.45993 h 36.590759 c 18.454088,-16.57045 46.837536,-19.53344 64.515001,1.44426 z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fontSize: 110,
    fontFamily: "Laca Medium",
    x: 250,
    y: 120
  }, "ALLERGO ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#87C7D1"
  }, "CENTRO"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    fontSize: 40,
    fontFamily: "Caviar Dreams",
    fontWeight: "bold",
    x: 440,
    y: 180
  }, "VOC\xCA LIVRE DE ALERGIAS")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.36ca660f96a84d052fdc764d9e647f8b.svg";
export { ForwardRef as ReactComponent };